import LoadingSpinner from "components/LoadingSpinners/LoadingSpinner";
import type { FunctionComponent } from "react";

const SidebarBusyOverlay: FunctionComponent<{showSpinner?:boolean}> = ({showSpinner = true}) =>
	(<div className="absolute inset-0 z-50 flex items-center justify-center bg-gray-100/50">
		{showSpinner && <LoadingSpinner />}
	</div>);
export default SidebarBusyOverlay;